import {addDays} from 'date-fns';

import i18n from '@dms/i18n';

export const relativeDates = [
  {date: new Date(), label: i18n.t('general.labels.today')},
  {date: addDays(new Date(), 1), label: i18n.t('general.labels.tomorrow')},
  {date: addDays(new Date(), 7), label: i18n.t('general.labels.in7Days')},
  {date: addDays(new Date(), 30), label: i18n.t('general.labels.in30Days')},
  {date: addDays(new Date(), 60), label: i18n.t('general.labels.in60Days')},
  {date: addDays(new Date(), 90), label: i18n.t('general.labels.in90Days')},
];
